import { createFileRoute } from '@tanstack/react-router';
import { SigningRequestList } from '@features/signing-requests/SigningRequestList';
import { validateTableSearch } from '@utils/tabHelpers';

export const Route = createFileRoute('/w/signing-requests/')({
  validateSearch: (search: Record<string, unknown>) =>
    validateTableSearch(search, { sortBy: 'createdOn', sortDir: 'desc' }),
  component: WorkpaySigningRequestsPage,
});

function WorkpaySigningRequestsPage() {
  const searchParams = Route.useSearch();
  return (
    <SigningRequestList
      routeTo="/w/signing-requests"
      searchParams={searchParams}
    />
  );
}
